import { render } from "./ThreeColumnGallery.vue?vue&type=template&id=8f6f4e12&scoped=true"
import script from "./ThreeColumnGallery.vue?vue&type=script&lang=js"
export * from "./ThreeColumnGallery.vue?vue&type=script&lang=js"

import "./ThreeColumnGallery.vue?vue&type=style&index=0&id=8f6f4e12&lang=scss&scoped=true"
import "./ThreeColumnGallery.vue?vue&type=style&index=1&id=8f6f4e12&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6f4e12"]])

export default __exports__